import css from "styled-jsx/css";

const COLORS = {
  hover: "#e6e9ef",
  selectedBackground: "#cce5ff",
  selectedText: "#0073ea"
};
export const componentStyles = css.global`
  .menu-container {
    display: flex;
    flex-direction: column;
    width: 240px;
  }
  a {
    text-decoration: none;
    color: inherit;
    .menu-item {
      display: flex;
      padding: 4px 8px;
      cursor: pointer;
      line-height: 26px;
      border-radius: 4px;
      font-size: 0.875rem;
      border: 1px solid transparent;
      .star-icon-wrapper {
        padding-right: 4px;
        display: flex;
        align-items: center;
        svg {
          max-height: 20px;
          padding-bottom: 2px;
        }
      }
    }
    .menu-item:hover {
      background-color: ${COLORS.hover};
    }
    .menu-item.selected {
      background-color: ${COLORS.selectedBackground};
      color: ${COLORS.selectedText};
    }
  }
`;
